import React, { useState } from "react";
import { IMemberListData } from "../../../exports/interfaces";
import { TextField } from "@mui/material";

const TableFilter = (props: {
  listMemberData: IMemberListData[];
  setFilteredData: React.Dispatch<React.SetStateAction<IMemberListData[]>>;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const [membershipType, setMembershipType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const handleSearch = () => {
    const filtered = props.listMemberData.filter((member) => {
      const attrs = member.attributes;

      const emailMatch =
        email === "" || attrs.Email?.toLowerCase() === email.toLowerCase();
      const locationMatch = location === "" || attrs.Country === location;
      const membershipMatch =
        membershipType === "" || attrs.Type_Of_Membership === membershipType;

      const membershipDate = new Date(attrs.Membership_Expiry);
      const fromMatch = fromDate === "" || membershipDate >= new Date(fromDate);
      const toMatch = toDate === "" || membershipDate <= new Date(toDate);

      return (
        emailMatch && locationMatch && membershipMatch && fromMatch && toMatch
      );
    });

    props.setFilteredData(filtered);
    props.setCurrentPage(1);
  };

  const handleReset = () => {
    setEmail("");
    setLocation("");
    setMembershipType("");
    setFromDate("");
    setToDate("");
    props.setFilteredData(props.listMemberData);
    props.setCurrentPage(1);
  };
  return (
    <>
      <div className="row" style={{ padding: "0px 10px" }}>
        <div className="col-xl-2">
          <div
            className="become-volunteer__input"
            style={{ marginBottom: "unset", marginTop: "10px" }}
          >
            <input
              type="text"
              placeholder="Email ID"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>
        <div className="col-xl-2">
          <div
            className="become-volunteer__input"
            style={{ marginBottom: "unset", marginTop: "10px" }}
          >
            <select
              name="Location All"
              className="become-volunteer__select"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            >
              <option value="" disabled>
                Location All
              </option>
              <option value="Nepal">Nepal</option>
              <option value="India">India</option>
            </select>
          </div>
        </div>
        <div className="col-xl-2">
          <div
            className="become-volunteer__input"
            style={{ marginBottom: "unset", marginTop: "10px" }}
          >
            <select
              name="Membership Type"
              className="become-volunteer__select"
              value={membershipType}
              onChange={(e) => setMembershipType(e.target.value)}
            >
              <option value="" disabled>
                Membership Type
              </option>
              <option value="ASSOCIATE + RESIDENT MEMBERSHIP (TWO YEARS)">
                ASSOCIATE + RESIDENT MEMBERSHIP (TWO YEARS)
              </option>
              <option value="FULL PAID MEMBERSHIP (ANNUALLY)">
                FULL PAID MEMBERSHIP (ANNUALLY)
              </option>
              <option value="ACCREDITATION MEMBERSHIP (ANNUALLY)">
                ACCREDITATION MEMBERSHIP (ANNUALLY)
              </option>
              <option value="CORPORATE MEMBERSHIP (TWO YEARS)">
                CORPORATE MEMBERSHIP (TWO YEARS)
              </option>
              <option value="AFFILIATE MEMBERSHIP HONORARY (ANNUALLY)">
                AFFILIATE MEMBERSHIP HONORARY (ANNUALLY)
              </option>
            </select>
          </div>
        </div>
        <div className="col-xl-2">
          <TextField
            label="From"
            type="date"
            fullWidth
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            sx={{
              marginTop: "10px",
              "& .MuiInputBase-root": {
                backgroundColor: "#f4f1ec",
                borderRadius: "8px",
              },
              "& .Mui-focused .MuiInputBase-input": {
                color: "#727272",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#727272",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
              "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
              "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "transparent",
                },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
        <div className="col-xl-2">
          <TextField
            label="To"
            type="date"
            fullWidth
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            sx={{
              marginTop: "10px",
              "& .MuiInputBase-root": {
                backgroundColor: "#f4f1ec",
                borderRadius: "8px",
              },
              "& .Mui-focused .MuiInputBase-input": {
                color: "#727272",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#727272",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
              "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },
              "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "transparent",
                },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
        <div className="col-xl-2">
          <div style={{ display: "flex", gap: "5px", marginTop: "10px" }}>
            <button
              className="thm-btn become-volunteer__btn"
              onClick={handleSearch}
            >
              <i className="icon-magnifying-glass11"></i>
            </button>
            <button
              className="thm-btn become-volunteer__btn"
              style={{ backgroundColor: "#2bb1ce" }}
              onClick={handleReset}
            >
              <i className="icon-loop2"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TableFilter;
